import { type SetStateAction, atom } from "jotai";
import { atomWithCache } from "jotai-cache";

import { $accessTokenFunc } from "../../authenication";
import { $docsApi } from "../../docsapi";
import atomWithDebounce from "../../utils/atomWithDebounce";

export const $searchUserQuery = atomWithDebounce<string>("", 300);
$searchUserQuery.$currentValueAtom.debugLabel = "searchUserQueryCurrent";

export const $searchUsers = atomWithCache(async (get) => {
	const isDebouncing = get($searchUserQuery.isDebouncingAtom);
	// Simply get the debounced value - atomWithCache will handle the reactivity
	if (isDebouncing) {
		return {
			isDebouncing: true,
			users: [],
		};
	}

	const query = get($searchUserQuery.$currentValueAtom).trim();

	// If query is empty, return empty array
	if (!query || query === "") {
		return {
			users: [],
			isDebouncing: get($searchUserQuery.isDebouncingAtom),
		};
	}

	const { getAccessTokenSilently } = get($accessTokenFunc);
	if (!getAccessTokenSilently) {
		throw new Error("Cannot search users without access token function");
	}
	const token = await getAccessTokenSilently();
	if (!token) {
		throw new Error("Cannot search users without access token");
	}
	const docsApi = get($docsApi);
	const users = await docsApi.users.query(query, token);

	return {
		users,
		isDebouncing: get($searchUserQuery.isDebouncingAtom),
	};
});
$searchUsers.debugLabel = "searchUsers";
